import { useSelector } from 'react-redux';
import { staticComponentValueConverter } from '../StaticComponentValues';
import { useMemo, useState } from 'react';
import { HexToHueConverter } from '../../../../../../../helper/ColorToHueConverter';

const ProfilePolicies_1 = ({ item }) => {
  const staticValues = useSelector(state => state.themeSlice?.staticValues);
  const customization = staticComponentValueConverter(item?.customization);

  return (
    <div
      style={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        padding: staticValues[20],
      }}
    >
      <div
        style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 20 }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
          }}
        >
          <div style={{ fontWeight: 500, fontSize: 18, color: 'var(--secondaryThemeColor)' }}>Gizlilik</div>
          <div>
            <svg width="20px" height="20px" viewBox="0 0 0.5 0.5" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M0.2 0.4a0.025 0.025 0 0 1 -0.018 -0.043L0.29 0.25 0.182 0.143a0.025 0.025 0 1 1 0.035 -0.035l0.125 0.125a0.025 0.025 0 0 1 0 0.035l-0.125 0.125A0.025 0.025 0 0 1 0.2 0.4"
                fill="var(--secondaryThemeColor)"
              />
            </svg>
          </div>
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
          }}
        >
          <div style={{ fontWeight: 500, fontSize: 18, color: 'var(--secondaryThemeColor)' }}>Mesafeli</div>
          <div>
            <svg width="20px" height="20px" viewBox="0 0 0.5 0.5" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M0.2 0.4a0.025 0.025 0 0 1 -0.018 -0.043L0.29 0.25 0.182 0.143a0.025 0.025 0 1 1 0.035 -0.035l0.125 0.125a0.025 0.025 0 0 1 0 0.035l-0.125 0.125A0.025 0.025 0 0 1 0.2 0.4"
                fill="var(--secondaryThemeColor)"
              />
            </svg>
          </div>
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
          }}
        >
          <div style={{ fontWeight: 500, fontSize: 18, color: 'var(--secondaryThemeColor)' }}>İade</div>
          <div>
            <svg width="20px" height="20px" viewBox="0 0 0.5 0.5" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M0.2 0.4a0.025 0.025 0 0 1 -0.018 -0.043L0.29 0.25 0.182 0.143a0.025 0.025 0 1 1 0.035 -0.035l0.125 0.125a0.025 0.025 0 0 1 0 0.035l-0.125 0.125A0.025 0.025 0 0 1 0.2 0.4"
                fill="var(--secondaryThemeColor)"
              />
            </svg>
          </div>
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
          }}
        >
          <div style={{ fontWeight: 500, fontSize: 18, color: 'var(--secondaryThemeColor)' }}>KVKK</div>
          <div>
            <svg width="20px" height="20px" viewBox="0 0 0.5 0.5" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M0.2 0.4a0.025 0.025 0 0 1 -0.018 -0.043L0.29 0.25 0.182 0.143a0.025 0.025 0 1 1 0.035 -0.035l0.125 0.125a0.025 0.025 0 0 1 0 0.035l-0.125 0.125A0.025 0.025 0 0 1 0.2 0.4"
                fill="var(--secondaryThemeColor)"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfilePolicies_1;
